// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos do "Criar novo ticket" */
.criar-novo-ticket-container {
    width: 100%;
}

.criar-novo-ticket-container .formulario-abrir-novo-chamado {
    width: 100%;
    padding: .6rem 1rem 1rem 1rem;
    background-color: var(--branco-padrao);
    border-radius: 0 0 8px 8px;
    box-shadow: 0 0 1rem rgba(0, 0, 0, .15);
}

#assunto-chamado {
    margin-bottom: 1rem;
}

.criar-novo-ticket-container .formulario-abrir-novo-chamado form {
    display: flex;
    flex-direction: column;
}

.container-input-chamado {
    position: relative;
    width: 100%;
}

.criar-novo-ticket-container .formulario-abrir-novo-chamado form .container-input-chamado {
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-weight: 600;
    font-size: .8rem;
    color: var(--text-color2);
}

.criar-novo-ticket-container .formulario-abrir-novo-chamado form .container-input-chamado label {
    margin: 0 0 .1rem .22rem;
}

.icon-azul {
    color: var(--azul-dixi);
    font-size: 1rem;
}

.container-input-chamado label {
    display: flex;
    flex-direction: row;
    align-self: flex-start;
    justify-content: center;
    gap: .1rem;
}

.container-input-chamado input, .container-input-chamado textarea {
    width: 100%;
    border: none;
    outline: none;
    border-radius: 8px;
    background-color: var(--fundo-input2);
    font-size: 1rem;
    padding: .7rem 1rem;
}

.container-input-chamado textarea {
    min-height: 9rem;
    max-height: 500px;
    resize: vertical;
    border-radius: 8px 8px 0 0;
    height: 14rem;
}

/* Estilos para os anexos, imagens e adicionais */
.anexos-e-adicionais-container {
    display: flex;
    background: var(--branco-interior-modais);
    border-bottom: solid 1px var(--fundo-input2);
    border-left: solid 1px var(--fundo-input2);
    border-right: solid 1px var(--fundo-input2);
    border-radius: 0 0 8px 8px;
    padding: .5rem .7rem;
    gap: .5rem;
    justify-content: space-between;
}

.anexos-e-adicionais-container label {
    font-size: 1.2rem;
}

.input-file-label {
    cursor: pointer;
    transition: all .3s ease-in-out;
    padding: .3rem;
}

.input-file-label:hover {
    color: var(--azul-dixi);
    background-color: var(--botao-hover-clarinho);
    border-radius: 5px;
}

.container-selecionar-arquivos {
    display: flex;
    gap: .5rem;
}

.imagens-adicionadas-pelo-usuario {
    display: flex;
    gap: .7rem;
    left: .7rem;
    bottom: .7rem;
    width: 90%;
    max-height: 80px;
    overflow: visible;
}

.container-imagem-selecionada svg {
    color: var(--vermelho-padrao);
    background-color: var(--branco-padrao);
    border-radius: 50%;
    transition: all .15s ease-in-out;
    cursor: pointer;
}

.container-imagem-selecionada svg:hover {
    color: var(--branco-padrao);
    background-color: var(--vermelho-padrao);
}

.imagens-adicionadas-pelo-usuario .imagem-selecionada-pelo-usuario-chamado {
    min-width: 60px;
    min-height: 60px;
    max-width: 60px;
    max-height: 60px;
    border-radius: 5px;
    object-fit: cover;
    pointer-events: none;
}

.informacoes-anexos-adicionados {
    display: flex;
    align-items: center;
    gap: .5rem;
}

.informacoes-anexos-adicionados .quantidade-arquivos-adicionados {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    font-weight: 600;
    background-color: var(--azul-desativado);
    color: var(--texto-azul);
    min-width: max-content;
    padding: 0 .2rem;
    min-width: 1.2rem;
    height: 1.4rem;
    border-radius: 3px;
}

.informacoes-anexos-adicionados .textos-arquivos-adicionados {
    font-weight: 600;
    color: var(--cinza-label-input-padrao);
    font-size: .8rem;
}

.container-global-anexos {
    width: 100%; 
    overflow-x: auto;
}

.escrita-anexos {
    width: 100%; 
    max-width: 100%;
    overflow-y: auto;
    overflow-x: auto;
    padding: 1rem 0.2rem 0 0.2rem;
    font-size: 1rem;
    font-weight: 600;
    color: var(--azul-dixi);
    box-sizing: border-box; 
}

.linha-anexos {
    margin-top: .4rem;
    color: var(--cinza-label-input-padrao);
} 

.container-anexos {
    flex-wrap: wrap;
    gap: 1rem;
    padding: 1rem 0.2rem 0.2rem 0.2rem;
    display: flex;
    overflow-x: auto;
    max-width: 100%;
}

.botao-remover-anexo, .botao-remover-imagem{
    position: absolute;
    color: var(--vermelho-padrao);
    background-color: var(--branco-interior-modais);
    border-radius: 50%;
    padding: .2rem;
    cursor: pointer;
    transition: all .15s ease-in-out;
}

.container-anexo-selecionado {
    min-height: 50px;
    max-height: 50px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    width: 15.6rem;
    flex-shrink: 0;
    background-color: var(--branco-interior-modais);
}

.container-interno-anexo {
    margin: .5rem;
    display: flex;
}

.imagem-previa-conteudo-anexo {
    color: var(--azul-dixi);
}

.informacoes-internas-anexo {
    padding-left: .4rem ;
    display: flex;
    flex-direction: column;
    width: 12rem;
    white-space: nowrap;   
    gap: .2rem;
}

.texto-tamanho-anexo-selecionado{
    font-size: .8rem;
    color: var(--cinza-label-input-padrao);
}

.nome-anexo-selecionado-pelo-usuario-chamado {
    font-size: .8rem; 
    text-overflow: ellipsis;  
    overflow: hidden;   
    font-weight: 600;
}

`, "",{"version":3,"sources":["webpack://./src/components/FormAbrirChamado/FormAbrirChamado.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,6BAA6B;IAC7B,sCAAsC;IACtC,0BAA0B;IAC1B,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,aAAa;AACjB;;AAEA,iDAAiD;AACjD;IACI,aAAa;IACb,yCAAyC;IACzC,4CAA4C;IAC5C,0CAA0C;IAC1C,2CAA2C;IAC3C,0BAA0B;IAC1B,oBAAoB;IACpB,UAAU;IACV,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,6CAA6C;IAC7C,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,aAAa;IACb,UAAU;IACV,WAAW;IACX,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,sCAAsC;IACtC,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,wCAAwC;IACxC,wBAAwB;IACxB,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,sCAAsC;IACtC,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,SAAS;IACT,kCAAkC;IAClC,aAAa;IACb,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,+CAA+C;IAC/C,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,wCAAwC;IACxC,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;AACpB","sourcesContent":["/* Estilos do \"Criar novo ticket\" */\n.criar-novo-ticket-container {\n    width: 100%;\n}\n\n.criar-novo-ticket-container .formulario-abrir-novo-chamado {\n    width: 100%;\n    padding: .6rem 1rem 1rem 1rem;\n    background-color: var(--branco-padrao);\n    border-radius: 0 0 8px 8px;\n    box-shadow: 0 0 1rem rgba(0, 0, 0, .15);\n}\n\n#assunto-chamado {\n    margin-bottom: 1rem;\n}\n\n.criar-novo-ticket-container .formulario-abrir-novo-chamado form {\n    display: flex;\n    flex-direction: column;\n}\n\n.container-input-chamado {\n    position: relative;\n    width: 100%;\n}\n\n.criar-novo-ticket-container .formulario-abrir-novo-chamado form .container-input-chamado {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    font-weight: 600;\n    font-size: .8rem;\n    color: var(--text-color2);\n}\n\n.criar-novo-ticket-container .formulario-abrir-novo-chamado form .container-input-chamado label {\n    margin: 0 0 .1rem .22rem;\n}\n\n.icon-azul {\n    color: var(--azul-dixi);\n    font-size: 1rem;\n}\n\n.container-input-chamado label {\n    display: flex;\n    flex-direction: row;\n    align-self: flex-start;\n    justify-content: center;\n    gap: .1rem;\n}\n\n.container-input-chamado input, .container-input-chamado textarea {\n    width: 100%;\n    border: none;\n    outline: none;\n    border-radius: 8px;\n    background-color: var(--fundo-input2);\n    font-size: 1rem;\n    padding: .7rem 1rem;\n}\n\n.container-input-chamado textarea {\n    min-height: 9rem;\n    max-height: 500px;\n    resize: vertical;\n    border-radius: 8px 8px 0 0;\n    height: 14rem;\n}\n\n/* Estilos para os anexos, imagens e adicionais */\n.anexos-e-adicionais-container {\n    display: flex;\n    background: var(--branco-interior-modais);\n    border-bottom: solid 1px var(--fundo-input2);\n    border-left: solid 1px var(--fundo-input2);\n    border-right: solid 1px var(--fundo-input2);\n    border-radius: 0 0 8px 8px;\n    padding: .5rem .7rem;\n    gap: .5rem;\n    justify-content: space-between;\n}\n\n.anexos-e-adicionais-container label {\n    font-size: 1.2rem;\n}\n\n.input-file-label {\n    cursor: pointer;\n    transition: all .3s ease-in-out;\n    padding: .3rem;\n}\n\n.input-file-label:hover {\n    color: var(--azul-dixi);\n    background-color: var(--botao-hover-clarinho);\n    border-radius: 5px;\n}\n\n.container-selecionar-arquivos {\n    display: flex;\n    gap: .5rem;\n}\n\n.imagens-adicionadas-pelo-usuario {\n    display: flex;\n    gap: .7rem;\n    left: .7rem;\n    bottom: .7rem;\n    width: 90%;\n    max-height: 80px;\n    overflow: visible;\n}\n\n.container-imagem-selecionada svg {\n    color: var(--vermelho-padrao);\n    background-color: var(--branco-padrao);\n    border-radius: 50%;\n    transition: all .15s ease-in-out;\n    cursor: pointer;\n}\n\n.container-imagem-selecionada svg:hover {\n    color: var(--branco-padrao);\n    background-color: var(--vermelho-padrao);\n}\n\n.imagens-adicionadas-pelo-usuario .imagem-selecionada-pelo-usuario-chamado {\n    min-width: 60px;\n    min-height: 60px;\n    max-width: 60px;\n    max-height: 60px;\n    border-radius: 5px;\n    object-fit: cover;\n    pointer-events: none;\n}\n\n.informacoes-anexos-adicionados {\n    display: flex;\n    align-items: center;\n    gap: .5rem;\n}\n\n.informacoes-anexos-adicionados .quantidade-arquivos-adicionados {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 1rem;\n    font-weight: 600;\n    background-color: var(--azul-desativado);\n    color: var(--texto-azul);\n    min-width: max-content;\n    padding: 0 .2rem;\n    min-width: 1.2rem;\n    height: 1.4rem;\n    border-radius: 3px;\n}\n\n.informacoes-anexos-adicionados .textos-arquivos-adicionados {\n    font-weight: 600;\n    color: var(--cinza-label-input-padrao);\n    font-size: .8rem;\n}\n\n.container-global-anexos {\n    width: 100%; \n    overflow-x: auto;\n}\n\n.escrita-anexos {\n    width: 100%; \n    max-width: 100%;\n    overflow-y: auto;\n    overflow-x: auto;\n    padding: 1rem 0.2rem 0 0.2rem;\n    font-size: 1rem;\n    font-weight: 600;\n    color: var(--azul-dixi);\n    box-sizing: border-box; \n}\n\n.linha-anexos {\n    margin-top: .4rem;\n    color: var(--cinza-label-input-padrao);\n} \n\n.container-anexos {\n    flex-wrap: wrap;\n    gap: 1rem;\n    padding: 1rem 0.2rem 0.2rem 0.2rem;\n    display: flex;\n    overflow-x: auto;\n    max-width: 100%;\n}\n\n.botao-remover-anexo, .botao-remover-imagem{\n    position: absolute;\n    color: var(--vermelho-padrao);\n    background-color: var(--branco-interior-modais);\n    border-radius: 50%;\n    padding: .2rem;\n    cursor: pointer;\n    transition: all .15s ease-in-out;\n}\n\n.container-anexo-selecionado {\n    min-height: 50px;\n    max-height: 50px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n    border-radius: 10px;\n    width: 15.6rem;\n    flex-shrink: 0;\n    background-color: var(--branco-interior-modais);\n}\n\n.container-interno-anexo {\n    margin: .5rem;\n    display: flex;\n}\n\n.imagem-previa-conteudo-anexo {\n    color: var(--azul-dixi);\n}\n\n.informacoes-internas-anexo {\n    padding-left: .4rem ;\n    display: flex;\n    flex-direction: column;\n    width: 12rem;\n    white-space: nowrap;   \n    gap: .2rem;\n}\n\n.texto-tamanho-anexo-selecionado{\n    font-size: .8rem;\n    color: var(--cinza-label-input-padrao);\n}\n\n.nome-anexo-selecionado-pelo-usuario-chamado {\n    font-size: .8rem; \n    text-overflow: ellipsis;  \n    overflow: hidden;   \n    font-weight: 600;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
